import { render } from "./external-examiner-dashboard.html?vue&type=template&id=56b0dd9c&scoped=true&ts=true&external"
import script from "./external-examiner-dashboard.ts?vue&type=script&lang=ts&external"
export * from "./external-examiner-dashboard.ts?vue&type=script&lang=ts&external"

import "./external-examiner-dashboard.scss?vue&type=style&index=0&id=56b0dd9c&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b0dd9c"]])

export default __exports__